import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  clearAll,
  clearResetBot,
  onGetCertificates,
  setCertificateDetails,
  setErrorMessageTransfereeUser,
  setLoadingTransfereeUser,
  showCertificateFormFunc,
  showResendLinkConfirmationFunc,
} from "../../../../config/redux/slice/transfereeUserSlice";
import { certicatesDatatable as TransfereeCerticatesDatatable } from "../../../../helpers/dataTables";
import { postRequest } from "../../../../helpers/request";
import { appApi } from "../../../../utils/endpoints/appApi";
import { appUrls } from "../../../../utils/urls/appUrls";
import { CertificateWrapper, DataTableWrapper } from "../../../components";
import CertificateFilter from "../CertificateFilter";
import CertificateUploadForm from "./CertificateUploadForm";
import ResendLinkConfirmation from "./ResendLinkConfirmation";
import {
  setCertificateDetailsGeneral,
  setIsRefreshed,
  showCommentFormFunc,
  showStatusChangeConfirmationFunc,
} from "../../../../config/redux/slice/appSlice";
import UploadSuccessModal from "./UploadSuccessModal";

export default function TransfereeCertificateManagement() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currencies } = useSelector((state) => state.app);
  const {
    transfereeUserLoading,
    transfereeUserErrorMsg,
    transfereeUserSuccessMsg,
    certificateManagement: {
      certificatesData,
      showUploadSuccessModal,
      newData,
      showCertificateForm,
      showResendLinkConfirmation,
    },
  } = useSelector((state) => state.transfereeUser);

  const { token, userData } = useSelector((state) => state.authData);

  useEffect(() => {
    dispatch(clearAll({}));
    dispatch(setCertificateDetails({ details: "", modal: false }));
    TransfereeCerticatesDatatable(
      certificatesData,
      setDetails,
      currencies,
      "TransfereeCertificatesTable"
    );
    getAllCertificates();
  }, []);

  const getAllCertificates = async () => {
    dispatch(clearAll({}));
    const data = {
      certificate_date: "0",
      issuer: "0",
      verification_status: "all",
    };
    const res = await postRequest(
      token,
      `${appApi.getCertificates}`,
      data,
      dispatch,
      setLoadingTransfereeUser,
      onGetCertificates,
      setErrorMessageTransfereeUser
    );
    //   if(res !== undefined && res.status < 400){
    //       setBanks(res.data.data)
    //   }
  };

  const setDetails = (data, type) => {
    dispatch(setIsRefreshed());
    dispatch(setCertificateDetailsGeneral({ details: data, modal: true }));
    if (type == "view-details") {
      dispatch(setCertificateDetails({ details: data, modal: true }));
      navigate(appUrls.certificates_view);
    }
  };

  useEffect(() => {
    if (newData) {
      TransfereeCerticatesDatatable(
        certificatesData,
        setDetails,
        currencies,
        "TransfereeCertificatesTable"
      );
      dispatch(clearResetBot());
    }
    if (transfereeUserSuccessMsg === "Certificate Uploaded Successfully") {
      getAllCertificates();
    }
  }, [newData, transfereeUserSuccessMsg]);

  return (
    <CertificateWrapper>
      {showUploadSuccessModal && (
        <UploadSuccessModal backdrop={showUploadSuccessModal} />
      )}
      {showCertificateForm && (
        <CertificateUploadForm backdrop={showCertificateForm} />
      )}
      {/* {showResendLinkConfirmation && <ResendLinkConfirmation backdrop={showResendLinkConfirmation}/>} */}
      <CertificateFilter />
      <DataTableWrapper
        tableButtons={
          userData?.isAdmin == false ? <AddCertificateButton /> : null
        }
        tableID="TransfereeCertificatesTable"
        tableName="Certificate Management"
      >
        <thead>
          <tr>
            <th>Reference ID</th>
            <th>Certificate Number</th>
            {/* <th>Currency</th> */}
            <th>Total Amount</th>
            <th>Amount Requested</th>
            <th>Approved Amount</th>
            <th>WHT Rate</th>
            <th>Amount Available</th>
            <th>Balance</th>
            <th>Swift No</th>
            <th>Certificate Issue Date</th>
            <th>Certificate Expiry Date</th>
            <th>Certificate Effective Date</th>
            {/* <th>Comment</th> */}
            <th>Status</th>
            <th>Currency</th>
            <th>Date</th>
            <th width={"9%"} data-orderable="false">
              Action
            </th>
          </tr>
        </thead>
        <tbody></tbody>
      </DataTableWrapper>
    </CertificateWrapper>
  );
}

function AddCertificateButton() {
  const dispatch = useDispatch();
  return (
    <div>
      <button
        onClick={() => dispatch(showCertificateFormFunc({ modal: true }))}
        className="btn btn-sm btn-outline-primary"
      >
        <i
          style={{ fontSize: "1rem" }}
          className="mdi mdi-plus-circle mr-1"
        ></i>
        Upload Certificate
      </button>
    </div>
  );
}
